// ---------------------------------------------------------------------------
// QuickTemplates — common data patterns created in one click.
// ---------------------------------------------------------------------------

import { useStudioStore } from '@/store/studio-store'
import { toast } from '@/store/toast-store'
import { Database, FileText } from 'lucide-react'

interface Props {
  blockName: string
}

export function QuickTemplates({ blockName }: Props) {
  const addVariable = useStudioStore((s) => s.addVariable)
  const addDatasource = useStudioStore((s) => s.addDatasource)
  const addEventBinding = useStudioStore((s) => s.addEventBinding)

  function createApiDataLoadSet() {
    // Creates: datasource + response variable + init event binding
    const dsName = 'api_data'
    const varName = 'apiResult'

    addDatasource(blockName, dsName, {
      type: 'rest',
      endpoint: '/api/data',
      method: 'GET',
    })
    addVariable(blockName, 'state', varName, {
      type: 'array',
      default: [],
    })
    addEventBinding(blockName, 'page:init', {
      flow: 'loadData',
    })
    toast.success('API Data Load Set created (datasource + variable + init event)')
  }

  function createFormSubmitSet() {
    // Creates: formData variable + form validation flow binding + submit flow binding
    addVariable(blockName, 'state', 'formData', {
      type: 'object',
      default: {},
    })
    addVariable(blockName, 'state', 'formErrors', {
      type: 'object',
      default: {},
    })
    addVariable(blockName, 'state', 'isSubmitting', {
      type: 'boolean',
      default: false,
    })
    addEventBinding(blockName, 'form:submit', {
      flow: 'validateAndSubmit',
    })
    toast.success('Form Submit Set created (3 variables + submit event)')
  }

  return (
    <div className="flex gap-1.5">
      <button
        onClick={createApiDataLoadSet}
        className="flex items-center gap-1 px-2 py-1 rounded text-[10px] text-muted-foreground hover:text-foreground hover:bg-accent border border-dashed border-border transition-colors"
        title="Creates datasource + variable + init flow binding"
      >
        <Database size={10} />
        API Data Load
      </button>
      <button
        onClick={createFormSubmitSet}
        className="flex items-center gap-1 px-2 py-1 rounded text-[10px] text-muted-foreground hover:text-foreground hover:bg-accent border border-dashed border-border transition-colors"
        title="Creates formData + formErrors + isSubmitting + submit event"
      >
        <FileText size={10} />
        Form Submit
      </button>
    </div>
  )
}
